<template>
    <v-container class="pa-5" fluid>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="ordersData"
                        :mobile-breakpoint="0"
                        name="labelsData"
                        hide-default-footer
                    >
                        <template #item.orderNumber="{item}">
                            {{ item.orderNumber }}
                        </template>
                        <template #item.orderProduct="{item}">
                            {{ item.orderProduct }}
                        </template>
                        <template #item.actions="{item}">
                            <div class="d-inline-flex">
                                <v-tooltip :open-delay="tooltipDelay" top>
                                    <template #activator="{on}">
                                        <v-btn
                                            icon
                                            v-on="on"
                                            @click="generateReport(item.shortOrderNumber)"
                                        >
                                            <v-icon color="secondary">
                                                mdi-file-pdf-box
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Generuj raport</span>
                                </v-tooltip>
                            </div>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { openPdfFile } from '@/utils/pdfHandler'
import { errorHandler } from '@/utils/errorHandler'
import tooltipDelay from '@/mixins/tooltip'

export default {
    name: 'Execution',
    mixins: [
        tooltipDelay
    ],
    props: {
        ordersData: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            order: {
                orderProduct: '',
                orderNumber: '',
                shortOrderNumber: ''
            },
            headers: [
                {
                    text: 'Nr zamówienia',
                    value: 'orderNumber',
                    sortable: false,
                },
                {
                    text: 'Produkt',
                    value: 'orderProduct',
                    sortable: false,
                    align: 'center',
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                }
            ],
            actionLoading: {
                generateReport: false
            }
        }
    },
    methods: {
        generateReport(orderNumber) {
            this.actionLoading.generateReport = true
            this.$store.dispatch('reportsAndAnalysis/orders/printOrderReport', {orderNumber: orderNumber})
                .then(response => {
                    openPdfFile(response.data)
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading.generateReport = false
                })
        }
    }
}
</script>